<template>
  <div>
    <v-tabs v-model="tab" background-color="primary" dark>
      <v-tab v-for="item in items" :key="item.id" :value="item.id">
        <v-icon class="mr-2">{{ item.icon }}</v-icon>
        {{ translate(item.tab) }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" :touchless="true">
      <v-tab-item v-for="(item, i) in items" :key="item.id">
        <div class="px-2">
          <component
            v-if="tab === i"
            :is="item.component"
            @switch-tab="switchTab"
          ></component>
        </div>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import {
  ReportTabGroupMealsTabCustomers2,
  ReportTabGroupMealsTabGroupedShiftMeals,
  ReportTabGroupMealsTabOrders,
  ReportTabGroupMealsTabRestaurants,
  ReportTabGroupMealsTabEmployees,
  ReportTabGroupMealsTabMeals,
  ReportTabGroupMealsTabTaken,
  ReportMealsTabReservedMeals,
} from "@/components/report/group-meals";

export default {
  data() {
    return {
      tab: null,
    };
  },
  methods: {
    switchTab(tabIndex) {
      this.tab = tabIndex;
    },
  },
  computed: {
    items() {
      return [
        {
          id: 1,
          tab: this.$t("meals_main"),
          icon: "mdi-food-drumstick",
          component: ReportTabGroupMealsTabMeals,
        },
        {
          id: 2,
          tab: this.$t("users"),
          icon: "mdi-account-multiple",
          component: ReportTabGroupMealsTabEmployees,
        },
        {
          id: 3,
          tab: this.$t("ordered_1"),
          icon: "mdi-grid",
          component: ReportTabGroupMealsTabOrders,
        },
        // {
        //   id: 4,
        //   tab: this.$t("o"),
        //   icon: "mdi-format-list-bulleted-type",
        //   component: ReportTabGroupMealsTabCustomers,
        // },
        {
          tab: this.$t("ordered_taken_meals"),
          icon: "mdi-truck-delivery",
          component: ReportTabGroupMealsTabTaken,
        },
        {
          id: 5,
          tab: this.$t("orderers"),
          icon: "mdi-format-list-bulleted-type",
          component: ReportTabGroupMealsTabCustomers2,
        },
        {
          id: 6,
          tab: this.$t("r_o"),
          icon: "mdi-food-variant",
          component: ReportMealsTabReservedMeals,
        },
        {
          id: 7,
          tab: this.$t("restaurants"),
          component: ReportTabGroupMealsTabRestaurants,
          icon: "mdi-format-list-bulleted-type",
        },
        {
          id: 8,
          tab: this.$t("groups_meal"),
          component: ReportTabGroupMealsTabGroupedShiftMeals,
          icon: "mdi-view-grid-plus",
        },
      ];
    },
  },
};
</script>
